import { _getGlobalState } from 'mobx';
export class RuntimeMobx {
    parent;
    unstableStateCount = 0;
    constructor(parent) {
        this.parent = parent;
    }
    get globalMobxState() {
        return _getGlobalState();
    }
    get areStateChangesAllowed() {
        return this.globalMobxState.allowStateChanges && this.globalMobxState.computationDepth === 0;
    }
    get isCurrentlyComputingDerivation() {
        return !this.areStateChangesAllowed;
    }
    get isInUnstableState() {
        return this.unstableStateCount > 0;
    }
}
